import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { partnerService } from "../../Services/partner.service";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services/global.service";
import { iban, numbersOnly, lettersOnly, lettersAndNumbers, address, email, OIB } from "../../Config/Regex";
import Select from "react-select";
import Tooltip from "../Common/Tooltip";

export default function UpdatePartner(props) {
  let id = props.match.params.partnerId;
  const { t: translator } = useTranslation();
  const { locName, locTenant } = useContext(GlobalContext);
  const [isDisabled, setDisable] = useState(true);
  const [countries, setCountries] = useState([]);
  const [tenants, setTenants] = React.useState();
  const [isCroatia, setIsCroatia] = useState(true);
  const [postOffices, setPostOffices] = useState([]);
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const history = useHistory();

  const [partner, setPartner] = useState({
    partnerId: id,
    isActive: true,
    tenantId: null,
    name: "",
    description: "",
    taxNumber: "",
    street: "",
    streetNumber: "",
    streetNumberExtension: "",
    city: "",
    countryId: null,
    postalNumber: "",
    iban: "",
    email: "",
    phone: "",
    discount: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    partnerService
      .getById(id)
      .then((res) => {
        setPartner(res.data);
      })
      .catch((err) => console.log(err.response));

    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getTenants()
      .then((data) => {
        setTenants(data.data);
      })
      .catch(() => history.push("/Error"));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const getCity = (id, postal) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        document.getElementsByName("city")[0].value = res.data.data.name;
        setCity(res.data.data.name);
      })
      .catch(() => history.push("/Error"));
  };

  const [city, setCity] = useState();

  const onSubmit = (data) => {
    partnerService
      .update({
        partnerId: id,
        isActive: data.isActive,
        tenantId: Number(partner.tenantId),
        name: data.name,
        description: data.description,
        taxNumber: data.taxNumber,
        street: data.street,
        streetNumber: Number(data.streetNumber),
        streetNumberExtension: data.streetNumberExtension,
        city: partner.countryId == 1 ? data.city : data.City,
        countryId: Number(data.countryId),
        postalNumber:
          partner.countryId == 1 ? data.postalNumber.value : data.postalNumber,
        iban: data.iban,
        email: data.email,
        phone: data.phone,
        discount: Number(data.discount),
        branch: data.branch,
      })
      .then((res) => {
        res.data.success
          ? setModal({
            show: true,
            title: translator("Partner-UpdatePartner-SuccessModal-Title"),
            text: translator("Partner-UpdatePartner-SuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setModal({
            show: true,
            title: translator("Partner-UpdatePartner-UnsuccessModal-Title"),
            text: translator("Partner-UpdatePartner-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("Partner-UpdatePartner-UnsuccessModal-Title"),
          text: translator("Partner-UpdatePartner-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap subtitle={translator("Partner-UpdatePartner-Subtitle")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-MainData")}
            </legend>

            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-OIB")}</label>{" "}
              <Tooltip text={translator("Partner-OIB-Msg")} />
              {partner && (
                <input
                  disabled
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    pattern: partner.countryId == 1 ? OIB : null,
                    validate: () =>
                      partner.countryId == 1 
                        ? partnerService.validateOib(partner.taxNumber)
                        : null,
                  })}
                  name="taxNumber"
                  defaultValue={partner.taxNumber}
                />
              )}
              {errors.taxNumber && errors.taxNumber.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.taxNumber && errors.taxNumber.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-OIBLength")}
                </p>
              )}
              {errors.taxNumber && errors.taxNumber.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-OIBNotValid")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Name")}</label>{" "}
              <Tooltip text={translator("Partner-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 100,
                })}
                name="name"
                defaultValue={partner.name}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength100")}
                </p>
              )}
            </div>
             <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Branch")}</label>{" "}
              <Tooltip text={translator("Partner-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  maxLength: 100,
                })}
                name="branch"
                defaultValue={partner.branch}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength100")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("PartnersUpdate-IBAN")}</label>{" "}
              <Tooltip text={translator("Partner-IBAN-Msg")} />
              {partner && (
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: false,
                    pattern: partner.countryId == 1 ? iban : null,
                  })}
                  name="iban"
                  defaultValue={partner.iban}
                />
              )}
              {errors.iban && errors.iban.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-IBAN")}
                </p>
              )}
              <p>*{translator("AddPartner-MsgChangeStateIban")}</p>
            </div>
           
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-AdressData")}
            </legend>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Street")}</label>{" "}
              <Tooltip text={translator("Partner-Street-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: address,
                  maxLength: 150,
                })}
                name="street"
                defaultValue={partner.street}
              />
              {errors.street && errors.street.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersOnly")}
                </p>
              )}
              {errors.street && errors.street.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength150")}
                </p>
              )}
            </div>
            <div className="form-row">
              <div className="form-group col-md-8">
                <label htmlFor="streetNumber">
                  {translator("Partner-UpdatePartner-StreetNumber")}{" "}
                  <Tooltip text={translator("Partner-StreetNumber-Msg")} />
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="streetNumber"
                  ref={register({
                    required: false,
                    pattern: numbersOnly,
                    maxLength: 6,
                  })}
                  defaultValue={partner.streetNumber}
                />
                {errors.streetNumber &&
                  errors.streetNumber.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength6")}
                    </p>
                  )}
                {errors.streetNumber &&
                  errors.streetNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumbersOnly")}
                    </p>
                  )}
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="streetNumberExtension">
                  {translator("Partner-UpdatePartner-StreetNumberExtension")}
                </label>{" "}
                <Tooltip
                  text={translator("Partner-StreetNumberExtension-Msg")}
                />
                <input
                  type="text"
                  className="form-control"
                  name="streetNumberExtension"
                  ref={register({ maxLength: 10 })}
                  defaultValue={partner.streetNumberExtension}
                />
                {errors.streetNumberExtension &&
                  errors.streetNumberExtension.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength10")}
                    </p>
                  )}
              </div>
            </div>

            {partner.countryId == 1 && isCroatia ? (
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("Partner-UpdatePartner-ZipCode")}
                  </label>{" "}
                  <Tooltip text={translator("Partner-ZipCode-Msg")} />
                  {postOffices.length != 0 && (
                    <Controller
                      as={Select}
                      options={
                        postOffices &&
                        postOffices.map((p) => ({
                          id: p.id,
                          label: p.name,
                          value: p.name,
                        }))
                      }
                      name="postalNumber"
                      defaultValue={{
                        label:
                          postOffices.length != 0 ? partner.postalNumber : "",
                        value:
                          postOffices.length != 0 ? partner.postalNumber : "",
                      }}
                      control={control}
                      onChange={function (event) {
                        getCity(event[0].id, event[0].label);
                        return event[0];
                      }}
                    />
                  )}
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("Partner-UpdatePartner-City")}
                  </label>{" "}
                  <Tooltip text={translator("Partner-City-Msg")} />
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    name="city"
                    ref={register()}
                    defaultValue={partner.city}
                  />
                </div>
              </div>
            ) : (
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("Partner-UpdatePartner-ZipCode")}
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control"
                    name="postalNumber"
                    defaultValue={partner.postalNumber}
                    ref={register({
                      maxLength: 10,
                      required: false,
                      pattern: numbersOnly,
                    })}
                  />
                  {errors.postalNumber &&
                    errors.postalNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                  {errors.postalNumber &&
                    errors.postalNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumbersOnly")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("Partner-UpdatePartner-City")}
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control"
                    name="City"
                    defaultValue={partner.city}
                    ref={register({
                      maxLength: 100,
                      required: false,
                      pattern: lettersOnly,
                    })}
                  />
                  {errors.City && errors.City.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength100")}
                    </p>
                  )}
                  {errors.City && errors.City.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-LettersOnly")}
                    </p>
                  )}
                </div>
              </div>
            )}

            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-State")}</label>
              {countries && (
                <select
                  disabled
                  className="form-control"
                  name="countryId"
                  ref={register({ required: false })}
                  value={Number(partner.countryId)}
                  onChange={(e) => {
                    setPartner({ ...partner, countryId: e.target.value });
                    if (e.target.value == 1) {
                      setIsCroatia(true);
                    } else {
                      setIsCroatia(false);
                    }
                  }}
                >
                  {countries.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {e.name}
                      </option>
                    );
                  })}
                </select>
              )}
            </div>
             <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Description")}</label>{" "}
              <Tooltip text={translator("Partner-Description-Msg")} />
              <textarea
                id="textArea"
                rows="4"
                className="form-control"
                name="description"
                ref={register({ maxLength: 250 })}
                defaultValue={partner.description}
              />
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator(
                      "ValidationMsg-MaxLength-HundredAndFiftyCharacters"
                    )}
                  </p>
                )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-ContactData")}
            </legend>
            <div className="form-group">
              <label>Email</label>{" "}
              <Tooltip text={translator("Partner-Email-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: email,
                  maxLength: 254,
                })}
                name="email"
                defaultValue={partner.email}
              />
              {errors.email && errors.email.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
              {errors.email && errors.email.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-PhoneNumber")}</label>{" "}
              <Tooltip text={translator("Partner-PhoneNumber-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: numbersOnly,
                  maxLength: 20,
                })}
                name="phone"
                defaultValue={partner.phone}
              />
              {errors.phone && errors.phone.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
              {errors.phone && errors.phone.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-NumbersOnly")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Discount")}</label>{" "}
              <Tooltip text={translator("Item-ConsummationTax-Msg")} />
              <div className="input-group">
                <input
                  type="number"
                  min="0"
                  step=".01"
                  className="form-control"
                  name="discount"
                  ref={register({ required: false, min: 0, max: 100 })}
                  defaultValue={partner.discount}
                />
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">
                    %
                  </span>
                </div>
              </div>
              {errors.pp && errors.pp.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.pp &&
                (errors.pp.type === "min" || errors.pp.type === "max") && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PP")}
                  </p>
                )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
